import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { INDONESIA_COMPLIANCE_CHECKLIST } from '../../utils/constants';
import { Shield, FileText, Lock, ExternalLink, CheckCircle } from 'lucide-react';
export function Indonesia() {
  const breadcrumbs = [{
    label: 'Compliance',
    path: '/compliance'
  }, {
    label: 'Indonesia (UU PDP)'
  }];
  return <Layout breadcrumbs={breadcrumbs} data-id="element-1765">
      <div className="container mx-auto px-4 py-12" data-id="element-1766">
        <div className="mb-12" data-id="element-1767">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-1768">
            <Shield className="h-3 w-3 mr-2" data-id="element-1769" />
            Compliance / Indonesia
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-1770">
            Cybersecurity Compliance — Indonesia
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-1771">
            Technical implementation of Law No. 27 of 2022 on Personal Data
            Protection (UU PDP).
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1772">
          <div className="lg:col-span-2 space-y-12" data-id="element-1773">
            <section data-id="element-1774">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1775">
                <FileText className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1776" />
                UU PDP Summary
              </h2>
              <div className="grid md:grid-cols-2 gap-4" data-id="element-1777">
                <Card className="p-5 bg-slate-900/50" data-id="element-1778">
                  <h3 className="font-bold text-slate-100 mb-2" data-id="element-1779">
                    Personal Data
                  </h3>
                  <p className="text-sm text-slate-400" data-id="element-1780">
                    Regulates general personal data (name, address) & specific
                    data (health, biometric, financial).
                  </p>
                </Card>
                <Card className="p-5 bg-slate-900/50" data-id="element-1781">
                  <h3 className="font-bold text-slate-100 mb-2" data-id="element-1782">
                    Data Subject Rights
                  </h3>
                  <p className="text-sm text-slate-400" data-id="element-1783">
                    Right to know, correct, terminate processing, and delete
                    data.
                  </p>
                </Card>
                <Card className="p-5 bg-slate-900/50" data-id="element-1784">
                  <h3 className="font-bold text-slate-100 mb-2" data-id="element-1785">
                    Security Obligations
                  </h3>
                  <p className="text-sm text-slate-400" data-id="element-1786">
                    Mandatory to maintain confidentiality, integrity, and
                    availability of personal data.
                  </p>
                </Card>
                <Card className="p-5 bg-slate-900/50" data-id="element-1787">
                  <h3 className="font-bold text-slate-100 mb-2" data-id="element-1788">
                    Breach Reporting
                  </h3>
                  <p className="text-sm text-slate-400" data-id="element-1789">
                    Mandatory to report data protection failures within 3x24
                    hours.
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-1790">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1791">
                <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1792" />
                Technical Control Mapping
              </h2>
              <div className="overflow-x-auto" data-id="element-1793">
                <table className="w-full text-left border-collapse" data-id="element-1794">
                  <thead data-id="element-1795">
                    <tr className="border-b border-slate-800 text-slate-300" data-id="element-1796">
                      <th className="py-3 px-4" data-id="element-1797">UU PDP Obligation</th>
                      <th className="py-3 px-4" data-id="element-1798">Technical Control</th>
                      <th className="py-3 px-4" data-id="element-1799">Implementation</th>
                    </tr>
                  </thead>
                  <tbody className="text-slate-400 text-sm" data-id="element-1800">
                    <tr className="border-b border-slate-800/50" data-id="element-1801">
                      <td className="py-3 px-4" data-id="element-1802">Data Security</td>
                      <td className="py-3 px-4 text-cyan-400" data-id="element-1803">
                        Encryption, MFA, Backup
                      </td>
                      <td className="py-3 px-4" data-id="element-1804">
                        Database encryption, enable admin MFA, 3-2-1 backup.
                      </td>
                    </tr>
                    <tr className="border-b border-slate-800/50" data-id="element-1805">
                      <td className="py-3 px-4" data-id="element-1806">Access Restriction</td>
                      <td className="py-3 px-4 text-cyan-400" data-id="element-1807">IAM & RBAC</td>
                      <td className="py-3 px-4" data-id="element-1808">
                        Least Privilege principle, regular access review.
                      </td>
                    </tr>
                    <tr className="border-b border-slate-800/50" data-id="element-1809">
                      <td className="py-3 px-4" data-id="element-1810">Incident Reporting</td>
                      <td className="py-3 px-4 text-cyan-400" data-id="element-1811">
                        IR Plan + Runbook
                      </td>
                      <td className="py-3 px-4" data-id="element-1812">
                        Prepare report template & rapid response team.
                      </td>
                    </tr>
                    <tr data-id="element-1813">
                      <td className="py-3 px-4" data-id="element-1814">Accountability</td>
                      <td className="py-3 px-4 text-cyan-400" data-id="element-1815">
                        Logging & Audit
                      </td>
                      <td className="py-3 px-4" data-id="element-1816">
                        Store access logs for minimum 1 year (best practice).
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>

          <div className="space-y-6" data-id="element-1817">
            <Checklist id="indonesia-compliance" title="Compliance Checklist" items={INDONESIA_COMPLIANCE_CHECKLIST} data-id="element-1818" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-1819">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-1820">
                Official Resource
              </h3>
              <p className="text-sm text-slate-400 mb-4" data-id="element-1821">
                Always refer to the official law text for legal certainty.
              </p>
              <a href="https://peraturan.bpk.go.id/Details/229798/uu-no-27-tahun-2022" target="_blank" rel="noopener noreferrer" data-id="element-1822">
                <Button variant="secondary" fullWidth className="justify-between group" data-id="element-1823">
                  Read Law No. 27 of 2022
                  <ExternalLink className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-1824" />
                </Button>
              </a>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}